// /components/SelectRecipientModal/SelectRecipientModal.js
import React, { useEffect } from 'react'; // Rimuovi useState
import { Form } from 'react-bootstrap';

// Aggiungi currentSoggetto, rimuovi isLoading (gestito da CustomModal)
const SelectRecipientModal = ({ show, attestatoData, onSubjectChange, currentSoggetto }) => {
    // Rimuovi lo stato interno: const [soggetto, setSoggetto] = useState('corsista');

    useEffect(() => {
        // Quando la modale si apre, comunica al genitore il valore iniziale da usare
        if (show && attestatoData && onSubjectChange) {
            const initialSoggetto = attestatoData.soggetto_spedizione || 'corsista';
             // Inizializza lo stato del genitore solo se necessario
             if (currentSoggetto !== initialSoggetto) {
                 onSubjectChange(initialSoggetto);
             }
        }
        // Non serve reset qui, lo stato è gestito dal genitore
    // Aggiungi currentSoggetto alle dipendenze per coerenza
    }, [show, attestatoData ]);

const handleSubjectChange = (e) => {
        const newSoggetto = e.target.value;
        
        if (onSubjectChange) {
           onSubjectChange(newSoggetto);
        } else {
            console.error('SelectRecipientModal: onSubjectChange non è definito!'); // <-- LOG Errore
        }
    };

    const hasAgenzia = attestatoData?.id_agenzia;

    return (
        <Form.Group className="mb-3">
            <Form.Label className="fw-bold">A chi vuoi intestare la busta?</Form.Label>
            <div>
                <Form.Check
                    type="radio"
                    label="Corsista"
                    name="soggettoStampa"
                    id="stampaCorsista"
                    value="corsista"
                    // Leggi direttamente dalla prop currentSoggetto
                    checked={currentSoggetto === 'corsista'}
                    onChange={handleSubjectChange}
                />
                <Form.Check
                    type="radio"
                    label="Agenzia"
                    name="soggettoStampa"
                    id="stampaAgenzia"
                    value="agenzia"
                    // Leggi direttamente dalla prop currentSoggetto
                    checked={currentSoggetto === 'agenzia'}
                    onChange={handleSubjectChange}
                    disabled={!hasAgenzia}
                    title={!hasAgenzia ? "Il corsista non è associato a un\'agenzia" : ""}
                />
            </div>
            {/* Usa currentSoggetto per il messaggio di errore */}
            {!hasAgenzia && currentSoggetto === 'agenzia' && (
                <small className="text-danger d-block mt-2">
                    Attenzione: Il corsista non è associato a un'agenzia. Seleziona "Corsista".
                </small>
            )}
        </Form.Group>
    );
};

export default SelectRecipientModal;